<template>
  <kendo-dropdownlist
          ref="solCdRef"
          :data-source="solCdDataArray"
          :data-text-field="'solNm'"
          :data-value-field="'solCd'"
          :index="0"
          :style="'width: 100%;'"
          @change="onChangeSolCdDropdownList"
  >
  </kendo-dropdownlist>
</template>

<script>
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'

  import Vue from 'vue'

  Vue.prototype.EventBus = new Vue()

  export default {
    name   : 'SolutionDropdown',
    props  : {
      cmpyCd: {
        default: null,
      },
    },
    created: function () {
      this.getSolCdDropdownList(this.$props.cmpyCd)
    },
    watch  : {
      cmpyCd: function (cmpyCd) {
        this.getSolCdDropdownList(cmpyCd)
      },
    },
    methods: {
      getSolCdDropdownList: function (cmpyCd) {
        const vm = this
        let solutionListParam = {
          loginUserToken: sessionStorage.lutk,
          cmpyCd        : cmpyCd === null ? '' : cmpyCd,
        }

        ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/user/solutionListForCompany.json`, solutionListParam).then(function (response) {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }

          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }

          vm.solCdDataArray = response.data.resultData
        })
      },

      onChangeSolCdDropdownList: function (e) {

        const vm = this
        let data = {
          solCd: vm.$refs.solCdRef.kendoWidget().value(),
          solNm: vm.$refs.solCdRef.kendoWidget().text(),
        }
        vm.EventBus.$emit('onChangeDropdownSolutionComponent', data)

      },
    },
    data   : function () {
      return {
        solCdDataArray: [],
      }
    },
  }
</script>

<style scoped>

</style>
